import { AutoshipmentLogoMark, P1, P2 } from '@zooplus/ui-components';
import React from 'react';
import styles from './Article.module.scss';
import { ArticleImage } from '../../common/article-image/ArticleImage';
import { useSiteContext } from '@zooplus/commons-lang';
import { ProductInfo } from '../../../model/product';
import { getUrlLocalised, useTranslation } from '../../../hooks/use-translations';

export type ArticleProps = {
  article: ProductInfo;
};

export const Article = (props: ArticleProps) => {
  const { site } = useSiteContext();
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <a className={styles.image} href={getUrlLocalised(t, props.article.pdpUrl)}>
        <ArticleImage pictureUrl={props.article.pictureUrl} hasAusIcon={false} />
      </a>
      <div className={styles.infoWrapper}>
        <P1 bold={true} className={styles.name}>
          <a href={getUrlLocalised(t, props.article.pdpUrl)}>{props.article.productName}</a>
        </P1>
        <P2 className={styles.description}>{props.article.variantName}</P2>
        <div className={styles.numbers}>
          <P2 className={styles.quantity}>
            {t('examples.quantity', { quantity: props.article.quantity || 1 })}
          </P2>
          <div className={styles.prices}>
            <P1 bold={true} className={styles.regularPrice}>
              {props.article.originalPriceFormatted}
            </P1>
            <P1 bold={true} className={styles.ausPrice}>
              <AutoshipmentLogoMark realm={site.realm} className={styles.icon} size="small" />
              {props.article.discountedPriceFormatted}
            </P1>
          </div>
        </div>
      </div>
    </div>
  );
};
